/**
 * Crisp website identifier for the TU app.
 *
 * Single ID shared across all TU brands (pmr + tu) — we run one Crisp
 * workspace for the whole app.
 *
 * This is a public, client-side identifier (Crisp embeds it in the install
 * snippet served to every visitor), so it is safe to commit.
 */
export const CRISP_WEBSITE_ID = "f5ae1336-9e6b-4525-aba8-6a73739c36d2";
